export type LambdaProxyResponse<T = any> = {
  statusCode: number;
  body: T;
  headers?: Record<string, string>;
};

export const normalizeLambdaResponse = <T = any>(
  raw: unknown
): LambdaProxyResponse<T> => {
  if (
    raw &&
    typeof raw === "object" &&
    "statusCode" in raw &&
    raw.statusCode != null
  ) {
    const envelope = raw as {
      statusCode: number;
      body?: unknown;
      headers?: Record<string, string>;
    };

    let body = envelope.body;

    if (typeof body === "string") {
      try {
        body = JSON.parse(body);
      } catch {
        body = { message: body };
      }
    }

    return {
      statusCode: envelope.statusCode,
      body: body as T,
      headers: envelope.headers,
    };
  }

  return {
    statusCode: 200,
    body: raw as T,
  };
};

export const isLambdaErrorResponse = (response: LambdaProxyResponse) =>
  response.statusCode >= 400 || response.body?.status === "Error";

export const getLambdaResponseMessage = (response: LambdaProxyResponse) =>
  response.body?.message ||
  response.body?.errorMessage ||
  "Request failed. Please try again.";
